// removed by extract-text-webpack-plugin
module.exports = {"index":"_132fJNbX0mMmMNeAEDZ9S4","linkWrSolo":"_2mBGx5ukUQoY_G2s0zkZsn","link":"UunrQIWUpPyONfzq0zYV0","textWrapper":"_16rKI1JkuOm0fZnd72Yi7R","linkSolo":"_1osAdljLfv_gBS0JOadE1b","text":"_bcg7dqvdX-IjUksvdvD2","textUnderline":"_1gdYnMuzxZm2Ts-eohOH5C","textPhone":"_1uPy7P-0dRKFtVnEI-Rqvv","black":"_1i-QMl5pnVCTgjE7QS_qNL"};


//////////////////
// WEBPACK FOOTER
// ./src/blocks/PhoneAndAddress/index.css
// module id = 245
// module chunks = 0